var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.panelEditor
        ? _c(
            "EstimationsPanelEditor",
            _vm._b(
              {
                on: {
                  createPanel: _vm.handleCreatePanelCommand,
                  updatePanel: _vm.handleUpdatePanelCommand,
                  deletePanel: _vm.handleDeletePanelCommand,
                  close: _vm.closePanelEditor,
                },
              },
              "EstimationsPanelEditor",
              _vm.panelEditor,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.attributesManager != null
        ? _c(
            "AttributesSelector",
            _vm._b(
              {
                on: {
                  close: _vm.closeAttributesManager,
                  save: _vm.handleUpdatePanelAttributesSettingsCommand,
                },
              },
              "AttributesSelector",
              _vm.attributesManager,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _c("PanelAlternativesManager", {
        attrs: { viewModel: _vm.panelAlternativesManager },
        on: { save: _vm.handleUpdatePanelAlternativesSettingsCommand },
      }),
      _vm._v(" "),
      _c("PanelOpener", {
        attrs: { viewModel: _vm.panelOpener },
        on: {
          "open-panel": _vm.handleOpenPanelAccessCommand,
          "show-links": _vm.showAccessLinks,
        },
      }),
      _vm._v(" "),
      _c("SurveyAccessLinks", {
        attrs: { viewModel: _vm.surveyAccessLinks },
        on: {
          "send-email": _vm.handleSendEmailCommand,
          "download-links": _vm.downloadLinks,
        },
      }),
      _vm._v(" "),
      _c("PanelCloser", {
        attrs: { viewModel: _vm.panelCloser },
        on: { "close-access": _vm.handleClosePanelAccessCommand },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { "padding-top": "130px" } },
        [
          _c("PortfolioOrDecisionNavigation", {
            attrs: { workspaceId: _vm.workspaceId, projectId: _vm.projectId },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "row" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "col-lg-6 text-right" }, [
                _c("div", { staticClass: "dropdown d-inline-block" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-secondary dropdown-toggle",
                      staticStyle: { padding: "0.7em 2em" },
                      attrs: { type: "button", "data-toggle": "dropdown" },
                    },
                    [
                      _vm._v(
                        "\n                            Export to xls\n                        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "dropdown-menu" }, [
                    _c(
                      "a",
                      {
                        staticClass: "dropdown-item",
                        on: { click: _vm.downloadVotes },
                      },
                      [_vm._v("Votes")]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "dropdown-item",
                        on: { click: _vm.downloadDisagreements },
                      },
                      [_vm._v("Disagreements")]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-success",
                    staticStyle: { padding: "0.7em 2em" },
                    attrs: { role: "button" },
                    on: { click: _vm.showSurveyCreator },
                  },
                  [_vm._v("Create panel")]
                ),
                _vm._v(" "),
                _vm._m(1),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("hr", {
            staticStyle: { "border-color": "#bbb", margin: "20px 0 60px" },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "container" }, [
            !_vm.initialized
              ? _c("h3", [
                  _c("i", { staticClass: "fa fa-spinner fa-spin" }),
                  _vm._v(" Loading..."),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.initialized
              ? _c("div", [
                  _c(
                    "nav",
                    {
                      staticClass:
                        "navbar navbar-light navbar-expand-md bg-light",
                      attrs: { role: "navigation" },
                    },
                    [
                      _c(
                        "form",
                        {
                          staticClass: "form-inline my-2 my-lg-0 mr-2",
                          attrs: { role: "search" },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "input-group input-group-sm" },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model.trim",
                                    value: _vm.SearchPhrase,
                                    expression: "SearchPhrase",
                                    modifiers: { trim: true },
                                  },
                                ],
                                staticClass: "form-control form-control-sm",
                                attrs: {
                                  type: "search",
                                  placeholder: "Search",
                                  "aria-label": "Search",
                                },
                                domProps: { value: _vm.SearchPhrase },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.SearchPhrase =
                                      $event.target.value.trim()
                                  },
                                  blur: function ($event) {
                                    return _vm.$forceUpdate()
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _vm._m(2),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("form", { staticClass: "form-inline my-2 my-lg-0" }, [
                        _c("div", { staticClass: "dropdown" }, [
                          _vm._v("\n                            Filter by: "),
                          _c(
                            "a",
                            {
                              staticClass:
                                "text-primary font-weight-bold dropdown-toggle",
                              attrs: { "data-toggle": "dropdown" },
                            },
                            [_vm._v(_vm._s(_vm.FilterByOwnerLabel))]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "dropdown-menu",
                              staticStyle: {
                                "max-height": "250px",
                                "overflow-y": "auto",
                              },
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item my-2",
                                  on: {
                                    click: function ($event) {
                                      return _vm.setOwnerFilter(null)
                                    },
                                  },
                                },
                                [_c("span", [_vm._v("All owners")])]
                              ),
                              _vm._v(" "),
                              _vm._l(_vm.WorkspaceMembers, function (m) {
                                return _c(
                                  "a",
                                  {
                                    staticClass: "dropdown-item my-2",
                                    on: {
                                      click: function ($event) {
                                        return _vm.setOwnerFilter(m.Email)
                                      },
                                    },
                                  },
                                  [
                                    _c("span", [_vm._v(_vm._s(m.Name))]),
                                    _c("br"),
                                    _vm._v(" "),
                                    _c("small", [_vm._v(_vm._s(m.Email))]),
                                    _c("br"),
                                  ]
                                )
                              }),
                            ],
                            2
                          ),
                        ]),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row" },
                    _vm._l(_vm.SurveysView, function (s) {
                      return _c(
                        "div",
                        {
                          key: s.SurveyId,
                          staticClass: "col-lg-6 col-md-6 col-sm-6 col-xs-12",
                        },
                        [
                          _c("div", { staticClass: "card mt-2" }, [
                            _c("div", { staticClass: "card-body" }, [
                              _c("h5", { staticClass: "card-title" }, [
                                !s.SurveyStarted
                                  ? _c("i", {
                                      staticClass: "fa fa-lock text-danger",
                                      attrs: { title: "Survey is closed" },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                s.SurveyStarted
                                  ? _c("i", {
                                      staticClass:
                                        "fa fa-unlock-alt text-success",
                                      attrs: { title: "Survey is open" },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("span", [_vm._v(_vm._s(s.Name))]),
                                _c("br"),
                                _vm._v(" "),
                                _c("small", { staticClass: "text-muted" }, [
                                  _vm._v(
                                    "Owner: " + _vm._s(_vm.getOwnerName(s))
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              s.IsSaving
                                ? _c("p", { staticClass: "card-text" }, [
                                    _c("i", {
                                      staticClass: "fa fa-spinner fa-spin",
                                    }),
                                    _vm._v(" Saving...."),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              !s.IsSaving
                                ? _c("div", [
                                    _c("div", { staticClass: "row" }, [
                                      _c(
                                        "div",
                                        { staticClass: "col text-nowrap" },
                                        [
                                          _c(
                                            "a",
                                            {
                                              directives: [
                                                {
                                                  name: "sanitizedHref",
                                                  rawName: "v-sanitizedHref",
                                                  value:
                                                    _vm.url_AssessmentsPanelistsPage(
                                                      s.SurveyId
                                                    ),
                                                  expression:
                                                    "url_AssessmentsPanelistsPage(s.SurveyId)",
                                                },
                                              ],
                                              staticClass: "text-primary",
                                            },
                                            [
                                              _vm._v(
                                                "\n                                                Panelists: " +
                                                  _vm._s(s.RespondentsCount) +
                                                  "\n                                            "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "row" }, [
                                      _c(
                                        "div",
                                        { staticClass: "col text-nowrap" },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass: "text-primary",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.showAttributesManager(
                                                    s
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                                Attributes: " +
                                                  _vm._s(s.AttributesCount) +
                                                  "/" +
                                                  _vm._s(
                                                    _vm.TotalCriteriaCount
                                                  ) +
                                                  "\n                                            "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "row" }, [
                                      _c(
                                        "div",
                                        { staticClass: "col text-nowrap" },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass: "text-primary",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.showPanelAlternativesManager(
                                                    s
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                                " +
                                                  _vm._s(
                                                    _vm.AlternativesLabel
                                                  ) +
                                                  ": " +
                                                  _vm._s(
                                                    s.AlternativesViewName
                                                  ) +
                                                  "\n                                            "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("br"),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        directives: [
                                          {
                                            name: "sanitizedHref",
                                            rawName: "v-sanitizedHref",
                                            value:
                                              _vm.url_AssessmentsMeetingManagerPage(
                                                s.SurveyId
                                              ),
                                            expression:
                                              "url_AssessmentsMeetingManagerPage(s.SurveyId)",
                                          },
                                        ],
                                        staticClass:
                                          "btn btn-sm btn-outline-secondary",
                                      },
                                      [_vm._v("Review")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "btn btn-sm btn-outline-secondary",
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleUpdateAlternativesCommand(
                                              s
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("Save scores")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "dropdown d-inline-block",
                                      },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-sm btn-outline-secondary dropdown-toggle",
                                            attrs: {
                                              type: "button",
                                              "data-toggle": "dropdown",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                            Actions\n                                        "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "dropdown-menu" },
                                          [
                                            _c(
                                              "a",
                                              {
                                                staticClass: "dropdown-item",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.showSurveyEditor(
                                                      s
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("Edit")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "a",
                                              {
                                                staticClass: "dropdown-item",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.handleClonePanelCommand(
                                                      s
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("Clone")]
                                            ),
                                            _vm._v(" "),
                                            _c("div", {
                                              staticClass: "dropdown-divider",
                                            }),
                                            _vm._v(" "),
                                            !s.SurveyStarted
                                              ? _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "dropdown-item",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.showPanelOpener(
                                                          s.SurveyId
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("Open survey")]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            s.SurveyStarted
                                              ? _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "dropdown-item",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.showPanelCloser(
                                                          s.SurveyId
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("Close survey")]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c("div", {
                                              staticClass: "dropdown-divider",
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "a",
                                              {
                                                staticClass: "dropdown-item",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.deletePanel(s)
                                                  },
                                                },
                                              },
                                              [_vm._v("Delete")]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
                ])
              : _vm._e(),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "col-lg-6" }, [
      _c(
        "h1",
        {
          staticStyle: {
            "font-size": "2em",
            "font-weight": "300",
            color: "#33475b",
            margin: "0",
          },
        },
        [_vm._v("Assessments")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "a",
      {
        staticClass: "btn btn-outline-secondary btn-lg",
        attrs: {
          href: "https://www.transparentchoice.com/user-guide/scoring",
          title: "User guide: Score projects",
          target: "_blank",
        },
      },
      [_c("i", { staticClass: "fa fa-info", attrs: { "aria-hidden": "true" } })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("span", { staticClass: "input-group-append" }, [
      _c("span", { staticClass: "input-group-text" }, [
        _c("i", {
          staticClass: "fa-solid fa-magnifying-glass",
          attrs: { "aria-hidden": "true" },
        }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }